/**
 *
 * @page 用户中心入口
 *
 **/
import DecorationScheme from './DecorationScheme';
import DecorationDetail from '&/pages/user-center/DecorationDetail';
import HouseType from '&/pages/my-collection/HouseType';
// import CollectScheme from './CollectScheme';
import ProjectSpace from './ProjectSpace';
import CollectModel from '&/pages/my-collection/CollectModel';
import MaterialDetail from '&/pages/my-collection/MaterialDetail';
import ModelList from '&/pages/my-collection/ModelList';
// import CollectionShare from '&/pages/my-collection/CollectionShare';
import ProjectDetail from './ProjectDetail';
import SchemeDetail from './SchemeDetail';
import ModelBase from '&/pages/resource-lib/ModelBase';
import MaterialChartlet from '&/pages/resource-lib/MaterialChartlet';
import Line from '&/pages/resource-lib/Line';
import UploadMaterial from '&/pages/resource-lib/UploadMaterial';
import IntelligentDesign from '&/pages/order-manage/MemberOrder';
import OrderDetail from '&/pages/order-manage/OrderDetail';
import CloudServices from '&/pages/order-manage/ServiceOrder';
import RenderingVoucherOrders from '&/pages/order-manage/RenderingVoucherOrders';
import ProxyOrder from '&/pages/order-manage/proxyOrder';
import UploadModel from '&/pages/resource-lib/UploadModel';
import UploadLine from '&/pages/resource-lib/UploadLine';
import InteractiveMsg from './InteractiveMsg';
import SystemMsg from './SystemMsg';
import BasicInfo from './BasicInfo';
import ChangePassword from './ChangePassword';
import MemberList from './team-management/MemberList';
import RoleAuthority from '&/pages/team-management/RoleAuthority';
import InspirationList from '&/pages/user-center/InspirationList';
import { Menu, Breadcrumb } from 'antd';
import { inject, observer } from 'mobx-react';
import { setFold } from '&/api/personCenter/setting';
import FloorPlanDesign from '&/pages/floor-plan-design';
import FloorPlanEdit from '&/pages/floor-plan-design/edit';
// import ProjectDetail from '@/components/ProjectDetail';
import {
    Switch,
    Route,
    Redirect,
    useLocation,
    useHistory,
    useRouteMatch,
    Link,
} from 'react-router-dom';
import './index.scss';

import { Layout } from 'antd';

function UserCenter(props) {
    const { appStore } = props;

    const SUB_ROUTERS = [
        {
            label: '方案管理',
            path: 'schemeManagement',
            icon: 'icon-Floor-Plan-Edit-copy',
            children: [
                {
                    path: '/user-center/decoration-scheme',
                    component: DecorationScheme,
                    label: intl.get('userCenter.myScheme'),
                    isMenu: true,
                    children: [
                        {
                            path: '/decoration-design/:id', // 子路径
                            component: DecorationDetail,
                            label: intl.get('userCenter.planDetails'),
                        },
                    ],
                },
                {
                    path: '/user-center/floor-plan-scheme',
                    component: FloorPlanDesign,
                    label: '平面图方案',
                    isMenu: true,
                    children: [
                        {
                            path: '/detail/:id', // 子路径
                            component: FloorPlanEdit,
                            label: '编辑方案',
                        },
                        {
                            path: '/add', // 子路径
                            component: FloorPlanEdit,
                            label: '方案上传',
                        },
                    ],
                },
                {
                    path: '/user-center/inspiration-list',
                    component: InspirationList,
                    label: intl.get('userCenter.inspirationList'),
                    isMenu: true,
                    children: [],
                },
            ],
        },
        {
            label: intl.get('userCenter.projectSpace'),
            path: 'schemef',
            icon: 'icon-Icon-Project',
            children: [
                {
                    path: '/user-center/project-space',
                    component: ProjectSpace,
                    label: intl.get('userCenter.projectSpace'),
                    isMenu: true,
                    children: [
                        {
                            // path: '/detail',
                            // component: ProjectDetail,
                            path: '/project-detail',
                            component: ProjectDetail,
                            label: intl.get('projectSpace.projectDetail'),
                        },
                        {
                            path: '/scheme-detail',
                            component: SchemeDetail,
                            label: intl.get('projectSpace.schemeDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/member-list',
                    component: MemberList,
                    label: intl.get('team.list'),
                    isMenu: true,
                },
                {
                    path: '/user-center/role-authority',
                    component: RoleAuthority,
                    label: intl.get('team.roleAuthority'),
                    isMenu: true,
                },
            ],
        },
        {
            path: 'repository',
            label: intl.get('userCenter.repository'),
            icon: 'icon-Icon-Light',
            children: [
                {
                    path: '/user-center/model-base',
                    component: ModelBase,
                    label: intl.get('pages.modelBase'),
                    isMenu: true,
                    children: [
                        {
                            path: '/upload-model',
                            component: UploadModel,
                            label: intl.get('userCenter.batchUpload'),
                        },
                    ],
                },
                {
                    path: '/user-center/material-chartlet',
                    component: MaterialChartlet,
                    label: intl.get('userCenter.materialChartlet'),
                    isMenu: true,
                    children: [
                        {
                            path: '/upload-material',
                            component: UploadMaterial,
                            label: intl.get('userCenter.batchUpload'),
                        },
                    ],
                },
                {
                    path: '/user-center/line',
                    component: Line,
                    label: '线条轮廓',
                    isMenu: true,
                    children: [
                        {
                            path: '/upload-line',
                            component: UploadLine,
                            label: intl.get('userCenter.batchUpload'),
                        },
                    ],
                },
            ],
        },
        {
            label: intl.get('userCenter.myCollect'),
            path: 'collect',
            icon: 'icon-favorites',
            children: [
                {
                    path: '/user-center/collect-house-type',
                    component: HouseType,
                    label: intl.get('userCenter.collectHousetype'),
                    isMenu: true,
                },
                {
                    path: '/user-center/collect-model',
                    component: CollectModel,
                    label: intl.get('userCenter.collectModel'),
                    isMenu: true,
                    children: [
                        {
                            path: '/model-list',
                            component: ModelList,
                            label: intl.get('userCenter.collectList'),
                        },
                        {
                            path: '/material-detail/:id',
                            component: MaterialDetail,
                            label: intl.get('userCenter.viewDetail'),
                        },
                        // 个人版西安不做分享
                        /* {
                            path: '/collection-share',
                            component: CollectionShare,
                            label: intl.get('userCenter.collectionShare'),
                        }, */
                    ],
                },
                /* {
                    path: '/user-center/collect-scheme',
                    component: CollectScheme,
                    label: intl.get('userCenter.collectScheme'),
                    isMenu: true,
                }, */
            ],
        },
        {
            label: intl.get('userCenter.orderManage'),
            path: 'order',
            icon: 'icon-Clipboard',
            children: [
                {
                    path: '/user-center/intelligent-design',
                    component: IntelligentDesign,
                    label: intl.get('userCenter.intelligentDesignOrder'),
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail
                                    title={intl.get(
                                        'userCenter.intelligentOrderDetail'
                                    )}
                                />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/cloud-services',
                    component: CloudServices,
                    label: intl.get('userCenter.cloudServicesOrder'),
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail
                                    title={intl.get(
                                        'userCenter.cloudOrderDetail'
                                    )}
                                />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/rendering-voucher-orders',
                    component: RenderingVoucherOrders,
                    label: intl.get('userCenter.renderingVoucherOrders'),
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail
                                    title={intl.get(
                                        'userCenter.renderingVoucherOrdersDetails'
                                    )}
                                />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/proxy-orders',
                    component: ProxyOrder,
                    label: '户型代画订单',
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail title="户型代画订单详情" />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
            ],
        },
        {
            label: intl.get('userCenter.myMsg'),
            path: 'message',
            icon: 'icon-bell',
            children: [
                {
                    path: '/user-center/interactive-message',
                    component: InteractiveMsg,
                    label: intl.get('userCenter.interactiveMsg'),
                    isMenu: true,
                },
                {
                    path: '/user-center/system-message',
                    component: SystemMsg,
                    label: intl.get('userCenter.systemMsg'),
                    isMenu: true,
                },
            ],
        },
        {
            label: intl.get('userCenter.accountSetting'),
            path: 'settings',
            icon: 'icon-cog',
            children: [
                {
                    path: '/user-center/info',
                    component: BasicInfo,
                    label: intl.get('accountSetting.personalInfo'),
                    isMenu: true,
                },
                {
                    path: '/user-center/password',
                    component: ChangePassword,
                    label: intl.get('accountSetting.changePassword'),
                    isMenu: true,
                },
            ],
        },
    ];

    const SIDE_BAR = SUB_ROUTERS.map(p => ({
        ...p,
        children: p.children.filter(c => c.isMenu),
    }));

    // 判断当前页面是否显示二级路由
    const { pathname } = useLocation();
    const [activeKeys, setActiveKeys] = useState([]);

    const matchDecoration = useRouteMatch({
        path: '/user-center/decoration-scheme',
        strict: false, // 全路径?
        sensitive: true, // 大小写?
    });

    // 菜单自动匹配高亮
    useEffect(() => {
        const pathArr = pathname.split('/');
        const match = [`/user-center/${pathArr[2]}`];
        setActiveKeys(match);
        appStore.setIsNeedMobile(matchDecoration);
    }, [pathname]);

    const history = useHistory();
    const DEFAUT_ROUTER = SUB_ROUTERS.find(e =>
        e.children.some(ce => pathname.includes(ce.path))
    );
    const DEFAULT_OPEN = [DEFAUT_ROUTER?.path || 'schemeManagement'];
    const { SubMenu } = Menu;

    const [customLabel, setCustomLabel] = useState(''); // 自定义面包屑最后一个

    const [collapsed, setCollapsed] = useState(!!appStore.userInfo.personFold);
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
        let personFold = !collapsed ? 1 : 0;
        appStore.setUserInfo({ ...appStore.userInfo, personFold });
        setFold({ menuFold: personFold });
    };

    return (
        <Layout className="user-center">
            <Layout.Sider
                width={160}
                collapsedWidth={`${78 / 16}rem`}
                trigger={null}
                className="aside-menu"
                collapsible
                collapsed={collapsed}>
                <Menu
                    selectedKeys={activeKeys}
                    defaultOpenKeys={DEFAULT_OPEN}
                    triggerSubMenuAction="click"
                    mode="inline"
                    onClick={e => history.push(e.key)}>
                    {SIDE_BAR.map(p => (
                        <SubMenu
                            key={p.path}
                            popupClassName="app-sider-menu"
                            icon={<i className={`filled ${p.icon}`} />}
                            title={p.label}
                            label={p.label}>
                            {p.children.map(e => (
                                <Menu.Item className="menu-item" key={e.path}>
                                    <i className="memu__icon-mins" />
                                    {e.label}
                                </Menu.Item>
                            ))}
                        </SubMenu>
                    ))}
                </Menu>
                <div
                    className="ant-layout-sider-trigger"
                    style={{ width: !collapsed ? '158px' : '66px' }}
                    onClick={toggleCollapsed}>
                    {/* <div>{collapsed + ''}</div> */}
                    {collapsed ? (
                        <i className="outlined icon-Icon-Open" />
                    ) : (
                        <i className="outlined icon-Icon-Off" />
                    )}
                </div>
            </Layout.Sider>

            <Layout.Content className="user-center-content">
                <Switch>
                    {SUB_ROUTERS.map(p =>
                        p.children.map((e, i) => [
                            <Route
                                exact
                                key={i}
                                path={e.path}
                                render={props => {
                                    return (
                                        <>
                                            <Breadcrumb>
                                                <Breadcrumb.Item>
                                                    {p.label}
                                                </Breadcrumb.Item>
                                                <Breadcrumb.Item>
                                                    <Link to={e.path}>
                                                        {' '}
                                                        {e.label}
                                                    </Link>
                                                </Breadcrumb.Item>
                                            </Breadcrumb>

                                            <e.component {...props} />
                                        </>
                                    );
                                }}
                            />,
                            e.children &&
                                e.children.map((ce, ci) => (
                                    <Route
                                        exact
                                        key={ci}
                                        path={e.path + ce.path}
                                        render={props => {
                                            return (
                                                <>
                                                    <Breadcrumb>
                                                        <Breadcrumb.Item>
                                                            {p.label}
                                                        </Breadcrumb.Item>
                                                        <Breadcrumb.Item>
                                                            <Link to={e.path}>
                                                                {e.label}
                                                            </Link>
                                                        </Breadcrumb.Item>
                                                        <Breadcrumb.Item>
                                                            {customLabel ||
                                                                ce.label}
                                                        </Breadcrumb.Item>
                                                    </Breadcrumb>
                                                    <ce.component
                                                        {...props}
                                                        setBreadcrumb={
                                                            setCustomLabel
                                                        }
                                                    />
                                                </>
                                            );
                                        }}
                                    />
                                )),
                        ])
                    )}
                    <Redirect to="/user-center/decoration-scheme" />
                </Switch>
            </Layout.Content>
        </Layout>
    );
}

export default inject('appStore')(observer(UserCenter));
